/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EmptyTreeInfo,
  GetOwnerGroupTreeParams,
  GetOwnerGroupsByIdParams,
  GetSimpleOwnerGroupsByPermissionAreaParams,
  SimpleOwnerGroup
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetSimpleOwnerGroupsByPermissionAreaUrl = (params?: GetSimpleOwnerGroupsByPermissionAreaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/OwnerGroup/GetSimpleOwnerGroupsByPermissionArea?${stringifiedParams}` : `/api/OwnerGroup/GetSimpleOwnerGroupsByPermissionArea`
}

export const getSimpleOwnerGroupsByPermissionArea = async (params?: GetSimpleOwnerGroupsByPermissionAreaParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleOwnerGroup[]> => {

  return customInstance<SimpleOwnerGroup[]>(getGetSimpleOwnerGroupsByPermissionAreaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimpleOwnerGroupsByPermissionAreaQueryKey = (params?: GetSimpleOwnerGroupsByPermissionAreaParams,) => {
    return [
    `/api/OwnerGroup/GetSimpleOwnerGroupsByPermissionArea`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimpleOwnerGroupsByPermissionAreaQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError = ErrorType<unknown>>(params?: GetSimpleOwnerGroupsByPermissionAreaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleOwnerGroupsByPermissionAreaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>> = ({ signal }) => getSimpleOwnerGroupsByPermissionArea(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimpleOwnerGroupsByPermissionAreaQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>>
export type GetSimpleOwnerGroupsByPermissionAreaQueryError = ErrorType<unknown>


export function useGetSimpleOwnerGroupsByPermissionArea<TData = Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleOwnerGroupsByPermissionAreaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>,
          TError,
          Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleOwnerGroupsByPermissionArea<TData = Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError = ErrorType<unknown>>(
 params?: GetSimpleOwnerGroupsByPermissionAreaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>,
          TError,
          Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleOwnerGroupsByPermissionArea<TData = Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError = ErrorType<unknown>>(
 params?: GetSimpleOwnerGroupsByPermissionAreaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleOwnerGroupsByPermissionArea<TData = Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError = ErrorType<unknown>>(
 params?: GetSimpleOwnerGroupsByPermissionAreaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleOwnerGroupsByPermissionAreaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleOwnerGroupsByPermissionAreaSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError = ErrorType<unknown>>(params?: GetSimpleOwnerGroupsByPermissionAreaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleOwnerGroupsByPermissionAreaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>> = ({ signal }) => getSimpleOwnerGroupsByPermissionArea(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimpleOwnerGroupsByPermissionAreaSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>>
export type GetSimpleOwnerGroupsByPermissionAreaSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleOwnerGroupsByPermissionAreaSuspense<TData = Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleOwnerGroupsByPermissionAreaParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleOwnerGroupsByPermissionAreaSuspense<TData = Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError = ErrorType<unknown>>(
 params?: GetSimpleOwnerGroupsByPermissionAreaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleOwnerGroupsByPermissionAreaSuspense<TData = Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError = ErrorType<unknown>>(
 params?: GetSimpleOwnerGroupsByPermissionAreaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleOwnerGroupsByPermissionAreaSuspense<TData = Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError = ErrorType<unknown>>(
 params?: GetSimpleOwnerGroupsByPermissionAreaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroupsByPermissionArea>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleOwnerGroupsByPermissionAreaSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleOwnerGroupsUrl = () => {




  return `/api/OwnerGroup/GetSimpleOwnerGroups`
}

export const getSimpleOwnerGroups = async ( options?: Parameters<typeof customInstance>[1]): Promise<SimpleOwnerGroup[]> => {

  return customInstance<SimpleOwnerGroup[]>(getGetSimpleOwnerGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimpleOwnerGroupsQueryKey = () => {
    return [
    `/api/OwnerGroup/GetSimpleOwnerGroups`
    ] as const;
    }


export const getGetSimpleOwnerGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleOwnerGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleOwnerGroups>>> = ({ signal }) => getSimpleOwnerGroups({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimpleOwnerGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleOwnerGroups>>>
export type GetSimpleOwnerGroupsQueryError = ErrorType<unknown>


export function useGetSimpleOwnerGroups<TData = Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleOwnerGroups>>,
          TError,
          Awaited<ReturnType<typeof getSimpleOwnerGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleOwnerGroups<TData = Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleOwnerGroups>>,
          TError,
          Awaited<ReturnType<typeof getSimpleOwnerGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleOwnerGroups<TData = Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleOwnerGroups<TData = Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleOwnerGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleOwnerGroupsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleOwnerGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleOwnerGroups>>> = ({ signal }) => getSimpleOwnerGroups({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimpleOwnerGroupsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleOwnerGroups>>>
export type GetSimpleOwnerGroupsSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleOwnerGroupsSuspense<TData = Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleOwnerGroupsSuspense<TData = Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleOwnerGroupsSuspense<TData = Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleOwnerGroupsSuspense<TData = Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleOwnerGroupsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOwnerGroupsByIdUrl = (params?: GetOwnerGroupsByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/OwnerGroup/GetOwnerGroupsById?${stringifiedParams}` : `/api/OwnerGroup/GetOwnerGroupsById`
}

export const getOwnerGroupsById = async (params?: GetOwnerGroupsByIdParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleOwnerGroup[]> => {

  return customInstance<SimpleOwnerGroup[]>(getGetOwnerGroupsByIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerGroupsByIdQueryKey = (params?: GetOwnerGroupsByIdParams,) => {
    return [
    `/api/OwnerGroup/GetOwnerGroupsById`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOwnerGroupsByIdQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerGroupsById>>, TError = ErrorType<unknown>>(params?: GetOwnerGroupsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerGroupsByIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerGroupsById>>> = ({ signal }) => getOwnerGroupsById(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOwnerGroupsByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerGroupsById>>>
export type GetOwnerGroupsByIdQueryError = ErrorType<unknown>


export function useGetOwnerGroupsById<TData = Awaited<ReturnType<typeof getOwnerGroupsById>>, TError = ErrorType<unknown>>(
 params: undefined |  GetOwnerGroupsByIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerGroupsById>>,
          TError,
          Awaited<ReturnType<typeof getOwnerGroupsById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerGroupsById<TData = Awaited<ReturnType<typeof getOwnerGroupsById>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerGroupsById>>,
          TError,
          Awaited<ReturnType<typeof getOwnerGroupsById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerGroupsById<TData = Awaited<ReturnType<typeof getOwnerGroupsById>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOwnerGroupsById<TData = Awaited<ReturnType<typeof getOwnerGroupsById>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnerGroupsByIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOwnerGroupsByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerGroupsById>>, TError = ErrorType<unknown>>(params?: GetOwnerGroupsByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerGroupsByIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerGroupsById>>> = ({ signal }) => getOwnerGroupsById(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetOwnerGroupsByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerGroupsById>>>
export type GetOwnerGroupsByIdSuspenseQueryError = ErrorType<unknown>


export function useGetOwnerGroupsByIdSuspense<TData = Awaited<ReturnType<typeof getOwnerGroupsById>>, TError = ErrorType<unknown>>(
 params: undefined |  GetOwnerGroupsByIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerGroupsByIdSuspense<TData = Awaited<ReturnType<typeof getOwnerGroupsById>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupsByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerGroupsByIdSuspense<TData = Awaited<ReturnType<typeof getOwnerGroupsById>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupsByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOwnerGroupsByIdSuspense<TData = Awaited<ReturnType<typeof getOwnerGroupsById>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupsByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupsById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnerGroupsByIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOwnerGroupTreeUrl = (params?: GetOwnerGroupTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/OwnerGroup/GetOwnerGroupTree?${stringifiedParams}` : `/api/OwnerGroup/GetOwnerGroupTree`
}

export const getOwnerGroupTree = async (params?: GetOwnerGroupTreeParams, options?: Parameters<typeof customInstance>[1]): Promise<EmptyTreeInfo> => {

  return customInstance<EmptyTreeInfo>(getGetOwnerGroupTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerGroupTreeQueryKey = (params?: GetOwnerGroupTreeParams,) => {
    return [
    `/api/OwnerGroup/GetOwnerGroupTree`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOwnerGroupTreeQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerGroupTree>>, TError = ErrorType<unknown>>(params?: GetOwnerGroupTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerGroupTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerGroupTree>>> = ({ signal }) => getOwnerGroupTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOwnerGroupTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerGroupTree>>>
export type GetOwnerGroupTreeQueryError = ErrorType<unknown>


export function useGetOwnerGroupTree<TData = Awaited<ReturnType<typeof getOwnerGroupTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetOwnerGroupTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerGroupTree>>,
          TError,
          Awaited<ReturnType<typeof getOwnerGroupTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerGroupTree<TData = Awaited<ReturnType<typeof getOwnerGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerGroupTree>>,
          TError,
          Awaited<ReturnType<typeof getOwnerGroupTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerGroupTree<TData = Awaited<ReturnType<typeof getOwnerGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOwnerGroupTree<TData = Awaited<ReturnType<typeof getOwnerGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnerGroupTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOwnerGroupTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerGroupTree>>, TError = ErrorType<unknown>>(params?: GetOwnerGroupTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerGroupTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerGroupTree>>> = ({ signal }) => getOwnerGroupTree(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetOwnerGroupTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerGroupTree>>>
export type GetOwnerGroupTreeSuspenseQueryError = ErrorType<unknown>


export function useGetOwnerGroupTreeSuspense<TData = Awaited<ReturnType<typeof getOwnerGroupTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetOwnerGroupTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerGroupTreeSuspense<TData = Awaited<ReturnType<typeof getOwnerGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerGroupTreeSuspense<TData = Awaited<ReturnType<typeof getOwnerGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOwnerGroupTreeSuspense<TData = Awaited<ReturnType<typeof getOwnerGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetOwnerGroupTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOwnerGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnerGroupTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






